import React from "react";
import "./skeleton.scss"; // we will create this next

export const SkeletonCard = () => {
    return (
        <div className="row mb-4">
            <div className="col-6">
                <div className="skeleton-card">
                    <div className="skeleton-header shimmer"></div>
                    <div className="skeleton-text shimmer"></div>
                    <div className="skeleton-text shimmer"></div>
                    <div className="skeleton-footer">
                        <div className="skeleton-btn shimmer"></div>
                        <div className="skeleton-btn shimmer"></div>
                    </div>
                </div>
            </div>
            <div className="col-6">
                <div className="skeleton-card">
                    <div className="skeleton-header shimmer"></div>
                    <div className="skeleton-text shimmer"></div>
                    <div className="skeleton-text shimmer"></div>
                    <div className="skeleton-footer">
                        <div className="skeleton-btn shimmer"></div>
                        <div className="skeleton-btn shimmer"></div>
                    </div>
                </div>
            </div>
            <div className="col-6">
                <div className="skeleton-card">
                    <div className="skeleton-header shimmer"></div>
                    <div className="skeleton-text shimmer"></div>
                    <div className="skeleton-text shimmer"></div>
                    <div className="skeleton-footer">
                        <div className="skeleton-btn shimmer"></div>
                        <div className="skeleton-btn shimmer"></div>
                    </div>
                </div>
            </div>
            <div className="col-6">
                <div className="skeleton-card">
                    <div className="skeleton-header shimmer"></div>
                    <div className="skeleton-text shimmer"></div>
                    <div className="skeleton-text shimmer"></div>
                    <div className="skeleton-footer">
                        <div className="skeleton-btn shimmer"></div>
                        <div className="skeleton-btn shimmer"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonCard;
